module.exports = __webpack_public_path__ + "static/media/image_placeholder.d8bfd059.jpg";